<script>
import {
  footerShopInfosEmits,
  footerShopInfosProps,
  useFooterShopInfos
} from "./mixin";
import { footerProps } from "@/components/organisms/footer/mixin";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import LinksCollection from "@/components/molecules/links-collection/default";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Newsletter from "@/components/molecules/newsletter";

import bandeauLegalVapotage from "@/assets/images/bandeau-legal-vapotage.jpg";
import bandeauLegalAlcool from "@/assets/images/bandeau-legal-alcool.jpg";
import coraLogo from "@/assets/images/cora-logo.svg";

export default {
  name: "ShopInfos",
  components: {
    LinksCollection,
    Container,
    LazyImage,
    GridRow,
    GridCol,
    Newsletter
  },
  props: {
    ...footerProps(),
    ...footerShopInfosProps()
  },
  emits: [...footerShopInfosEmits()],
  setup(props, context) {
    const {
      aide,
      fidelite,
      responsable,
      donneesPersonnelle,
      servicePro,
      serviceLivraison,
      rappelProduit,
      showBanners,
      magasin,
      informations,
      siteCora,
      openStoreLocator
    } = useFooterShopInfos(props, context);

    return {
      aide,
      fidelite,
      responsable,
      donneesPersonnelle,
      servicePro,
      serviceLivraison,
      rappelProduit,
      showBanners,
      magasin,
      informations,
      siteCora,
      openStoreLocator,
      bandeauLegalVapotage,
      bandeauLegalAlcool,
      coraLogo
    };
  }
};
</script>

<template>
  <div>
    <div class="u-bgcolor-white u-py-lg">
      <Container>
        <div class="u-pl-sm u-pr-sm u-pl-none@md u-pr-none@md">
          <GridRow>
            <GridCol
              md="6"
              lg="4"
            >
              <LinksCollection
                :links="magasin"
                class="u-mb-lg"
                @openStoreLocator="openStoreLocator"
              >
                Mon magasin
              </LinksCollection>
              <LinksCollection
                :links="serviceLivraison"
                class="u-mb-lg"
              >
                Retrait & livraison
              </LinksCollection>
              <LinksCollection
                :links="rappelProduit"
                class="u-mb-lg"
              >
                Rappel produit
              </LinksCollection>
              <LinksCollection :links="aide">
                Aide et contact <br>
              </LinksCollection>
            </GridCol>
            <GridCol
              lg="4"
              md="6"
            >
              <LinksCollection
                :links="fidelite"
                class="u-mb-lg"
              >
                {{ isFidCarrefour ? "La Fidélité Carrefour" : "La fidélité" }}
              </LinksCollection>
              <LinksCollection
                class="u-mb-lg"
                :links="responsable"
              >
                Nos engagements
              </LinksCollection>
              <LinksCollection
                v-if="hasServicePro"
                :links="servicePro"
                class="u-mb-lg"
              >
                Services pro
              </LinksCollection>
              <LinksCollection :links="siteCora">
                Autres sites
              </LinksCollection>
            </GridCol>
            <GridCol
              lg="4"
              md="6"
            >
              <LinksCollection
                :links="informations"
                class="u-mb-lg"
              >
                Informations légales
              </LinksCollection>
            </GridCol>
            <GridCol
              lg="4"
              md="6"
            >
              <LinksCollection
                :links="donneesPersonnelle"
                class="u-mb-lg"
              >
                Mes données personnelles
              </LinksCollection>
              <Newsletter />
            </GridCol>
          </GridRow>
        </div>
      </Container>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
